import { Query } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { debounceTime, distinctUntilChanged, Observable } from 'rxjs';
import { IDoctorsMap, IShowAllState } from './show-all.interface';
import { ShowAllStore } from './show-all.store';

@Injectable({ providedIn: 'root' })
export class ShowAllQuery extends Query<IShowAllState> {
    isShowAllToggleEnabled$: Observable<boolean> = this.select((state) => state.isShowAllToggleEnabled).pipe(
        distinctUntilChanged(),
        debounceTime(500)
    );

    doctorsMap$: Observable<IDoctorsMap> = this.select((state) => state.doctorsMap);

    hasFullOrdersVisibility$: Observable<boolean> = this.select((state) => state.hasFullOrdersVisibility);

    get hasFullOrdersVisibility(): boolean {
        return this.store.getValue().hasFullOrdersVisibility;
    }

    constructor(protected store: ShowAllStore) {
        super(store);
    }
}
